import type { ProblemCreateRequest } from "@shared/types/problem";

export interface ValidationIssue {
  field: keyof ProblemCreateRequest | "form";
  message: string;
}

export function validateProblemCreate(
  input: ProblemCreateRequest,
): ValidationIssue[] {
  const issues: ValidationIssue[] = [];
  if (!input.name || input.name.trim().length === 0) {
    issues.push({ field: "name", message: "小課題名は必須です" });
  }
  if (!input.category || input.category.trim().length === 0) {
    issues.push({ field: "category", message: "大カテゴリは必須です" });
  }
  if (!input.theme || input.theme.trim().length === 0) {
    issues.push({ field: "theme", message: "中テーマは必須です" });
  }
  return issues;
}
